import retailJson from "./retail.json";
import { iconsAndImages } from "../../assets/images";
import "./style.scss";
import { FaUserCircle } from "react-icons/fa";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export const HolesaleRetailers = () => {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: true
        });
    }, []);
    return (
        <>
            <section className="py-5">
                <div className="container">
                    <div className="text-center mb-5">
                        <h1 className="bebas-neue-regular">
                            {retailJson?.wholesale?.title}
                        </h1>
                    </div>
                    <div className="row g-4 justify-content-center">
                        {retailJson?.wholesale?.listOfWholeSale?.map((details, index) => {
                            const animations = ["fade-right", "fade-down", "fade-down", "fade-left"];
                            const anim = animations[index % animations.length];
                            return (
                                <div
                                    className="col-6 col-md-6 col-lg-3"
                                    key={index}
                                    data-aos={anim}
                                >
                                    <div className="text-center h-100 p-4 bg-white rounded-4 wholesale-card">
                                        <div className="icon-circle mx-auto mb-3">
                                            <img
                                                src={iconsAndImages[details?.icon]}
                                                alt=""
                                                className="img-fluid"
                                                loading="lazy"
                                            />
                                        </div>
                                        <h5 className="pt-2 mb-2">
                                            {index + 1}. {details?.title}
                                        </h5>
                                        <p className="fw-normal small mb-0">
                                            {details?.content}
                                        </p>
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </section>
            <section style={{ backgroundColor: "#faf8f3" }} className="py-5">
                <div className="container">

                    <h1 className="bebas-neue-regular text-center mb-5">
                        {retailJson?.retail?.title}
                    </h1>

                    <div className="row g-4">
                        {retailJson?.retail?.listofRetail?.map((details, index) => (
                            <div
                                className="col-12 col-md-6"
                                key={index}
                                data-aos="fade-up"
                                data-aos-delay={index * 120}
                            >
                                <div className="bg-white p-4 rounded-4 shadow-sm h-100 retail-card">
                                    <p className="text-dark mb-4">
                                        "{details?.content}"
                                    </p>
                                    <div className="d-flex gap-3 align-items-center">
                                        {/* <img
                                            src={iconsAndImages?.[details?.icon]}
                                            alt={details?.name}
                                            className="rounded-circle retail-avatar"
                                            loading="lazy"
                                        /> */}
                                        <FaUserCircle className="rounded-circle retail-avatar" />
                                        <div>
                                            <h6 className="mb-1">{details?.name}</h6>
                                            <p className="mb-0 small text-muted">
                                                {details?.description}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    );
};
